<script lang="ts">
	import ThirdLevelNode from './_ThirdLevelNode.svelte';
	import type { CmsMainNavNodeRecord } from '$lib/data/types';
	import { createEventDispatcher } from 'svelte';
	import { getCmsTranslationForLocale } from '$lib/cms';
	import { isInternal } from '$lib/links';
	import { isMobile } from '$lib/stores';
	import { locale } from 'svelte-i18n';
	import { localizeUrl } from '$lib/i18n';

	export let node: CmsMainNavNodeRecord;

	const dispatch = createEventDispatcher<{ close: unknown }>();
</script>

<li class="nav-item" class:nav-expand={node.children}>
	<a
		href={$isMobile ? localizeUrl(node.url, $locale) : null}
		target={isInternal(node.url) ? null : '_blank'}
		rel={isInternal(node.url) ? null : 'external'}
		class="nav-link"
		class:nav-expand-link={node.children}
		on:click={$isMobile ? () => dispatch('close') : null}
	>
		{getCmsTranslationForLocale(node.translations, $locale).title}
	</a>

	{#if node.children}
		<ul class="nav-items nav-expand-content">
			{#each node.children as leafNode}
				<ThirdLevelNode node={leafNode} on:close />
			{/each}
		</ul>
	{/if}
</li>
